module.exports = __webpack_public_path__ + "img/mickey62.fba588d0.jpg";